import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import classNames from 'classnames';
import React from 'react';
import PropTypes from '../../helpers/propTypes';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },

  white: {
    color: 'white',
  },
});

export default function Loading({ dark }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CircularProgress className={classNames({ [classes.white]: !dark })} />
    </div>
  );
}

Loading.propTypes = {
  dark: PropTypes.bool,
};

Loading.defaultProps = {
  dark: false,
};
